import Vue from 'vue'

/**
    @filter 拼接省、市、区和详细地址
    @param {Address} info 后台地址接口传过来的address对象
 */
Vue.filter('addressDetail' ,info => {
    // if(info.provinceName === info.cityName){
    //     return info.cityName + info.districtName + info.standardAddress + info.address + info.houseNum
    // }else {
    //     return info.provinceName + info.cityName + info.districtName + info.standardAddress + info.address + info.houseNum
    // }
    
    let addrData = info.provinceName
    addrData = addrData.indexOf(info.cityName) > -1 ? addrData : addrData + info.cityName
    addrData = addrData.indexOf(info.districtName) > -1 ? addrData : addrData + info.districtName
    addrData = addrData + (info.standardAddress || '') + info.address + info.houseNum
    return addrData
})

/**
    @filter 电话号码分段
    @param {string} info 11位手机号码
 */
Vue.filter('phone' ,info => {
    let phone = info.split('')
    phone.splice(3,0," ")
    phone.splice(8,0," ")
    return phone.join("")
})
